import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

type Props = {
  offen: boolean;
  titel: string;
  text: string;
  bestaetigenText?: string;
  abbrechenText?: string;
  gefaehrlich?: boolean;
  laedt?: boolean;
  onBestaetigen: () => void;
  onAbbrechen: () => void;
};

/**
 * Wiederverwendbarer Bestätigungsdialog für unumkehrbare Aktionen.
 * Ersetzt sofort ausgeführte Löschungen und `window.confirm`.
 */
const BestaetigungsDialog = ({
  offen,
  titel,
  text,
  bestaetigenText = 'Bestätigen',
  abbrechenText = 'Abbrechen',
  gefaehrlich = false,
  laedt = false,
  onBestaetigen,
  onAbbrechen
}: Props) => (
  <Dialog
    open={offen}
    onClose={onAbbrechen}
    aria-labelledby="bestaetigung-titel"
    aria-describedby="bestaetigung-text"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle id="bestaetigung-titel">{titel}</DialogTitle>
    <DialogContent>
      <DialogContentText id="bestaetigung-text">{text}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onAbbrechen} disabled={laedt}>
        {abbrechenText}
      </Button>
      <Button
        onClick={onBestaetigen}
        color={gefaehrlich ? 'error' : 'primary'}
        variant="contained"
        disabled={laedt}
        autoFocus
      >
        {bestaetigenText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default BestaetigungsDialog;
